"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamps = void 0;
const random_1 = require("../crypto/random");
class Timestamps {
    static currentTimestamp() {
        return 'T' + Date.now().toString(16).padStart(11, '0');
    }
    static uniqueTimestamp() {
        const random = new random_1.RNGImpl().randomHexString(64);
        return Timestamps.currentTimestamp() + random;
    }
    static epochTimestamp() {
        return 'T' + ''.padStart(11 + 16, '0');
    }
    static parseUniqueTimestamp(unique) {
        return parseInt(unique.substring(1, 12), 16);
    }
    static compare(a, b) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        // returns sign(a - b)
        return a.localeCompare(b);
    }
    static before(a, b) {
        return Timestamps.compare(a, b) < 0;
    }
    static after(a, b) {
        return Timestamps.compare(a, b) > 0;
    }
}
exports.Timestamps = Timestamps;
//# sourceMappingURL=timestamps.js.map